import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { cloudinaryImageUrl } from '@scentregroup/ui/tools/cloudinary/image'
import { withAngleClasses } from '../../helpers/with-angle'
import style from './index.scss'

const getCloudinaryImageUrl = backgroundImage =>
  cloudinaryImageUrl({
    src: backgroundImage,
    numberofItems: 1,
    ratio: 'standard',
  })

const ContentGroup = ({
  angleClasses,
  angleOrigin,
  children,
  color,
  backgroundImage,
  skipTopPadding,
  className,
}) => (
  <div
    className={classNames(className, style[color], {
      [style.backgroundImage]: backgroundImage,
      [style.skipTopPadding]: skipTopPadding,
      [angleClasses[angleOrigin]]: angleOrigin,
    })}
    style={
      backgroundImage
        ? {
            backgroundImage: `url(${getCloudinaryImageUrl(backgroundImage)})`,
          }
        : null
    }
  >
    {children}
  </div>
)

ContentGroup.propTypes = {
  angleClasses: PropTypes.object.isRequired,
  angleOrigin: PropTypes.string,
  color: PropTypes.oneOf([
    'Grey',
    'Seasonal',
    'White',
    'LightSeasonal',
    'Transparent',
  ]).isRequired,
  backgroundImage: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  children: PropTypes.node.isRequired,
  skipTopPadding: PropTypes.bool,
  className: PropTypes.string,
}

ContentGroup.defaultProps = {
  skipTopPadding: false,
}

export default withAngleClasses(ContentGroup)
